<script setup>
defineProps({
  size: {
    type: String,
    default: 'md', // 'sm' | 'md' | 'lg'
  },
  showSubtitle: {
    type: Boolean,
    default: false,
  },
  light: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="flex items-center gap-3 select-none">
    <!-- Brand Icon -->
    <div
      :class="[
        'rounded-xl flex items-center justify-center font-black tracking-tighter shadow-md transition',
        size === 'sm' ? 'w-8 h-8 text-sm' : size === 'lg' ? 'w-12 h-12 text-xl' : 'w-10 h-10 text-base',
        light ? 'bg-white text-indigo-900 shadow-slate-200' : 'bg-indigo-600 text-white shadow-indigo-500/20'
      ]"
    >
      <span>M</span>
    </div>

    <!-- Wordmark -->
    <div class="flex flex-col">
      <span
        :class="[
          'font-extrabold tracking-tight leading-none',
          size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-xl',
          light ? 'text-slate-900' : 'text-white'
        ]"
      >
        Manza <span class="text-indigo-500 font-black">PPOB</span>
      </span>
      <span v-if="showSubtitle" class="text-xs text-slate-500 mt-0.5 font-medium">
        Platform Multi-Produk Digital
      </span>
    </div>
  </div>
</template>
